// React hooks and the element helper used everywhere

export const {
  useState,
  useMemo,
  useRef,
  useEffect,
  useCallback
} = React;
export const h = React.createElement;
